import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getDecisionMembers(axiosPrivate, id) {
	return axiosPrivate
		.get(`${apiURL}/decision/${id}/organization-unit.json`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function getAvailableDecisionMembers(axiosPrivate, id, isMaker, phrase) {
	return axiosPrivate
		.get(`${apiURL}/decision/${id}/available-unit.json${phrase ? "?phrase=" + phrase : ""}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function addDecisionMembers(axiosPrivate, cb, isMaker, id, unitId) {
	return axiosPrivate
		.post(`${apiURL}/decision/${id}/organization-unit/${unitId}.json`, null)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success(`Unit decision ${isMaker ? "maker" : "receiver"} - added`);
				cb();
				return res;
			} else {
				toast.error(`Unit decision ${isMaker ? "maker" : "receiver"} failed to be added`);
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteDecisionMembers(axiosPrivate, cb, isMaker, id, unitId) {
	return axiosPrivate
		.delete(`${apiURL}/decision/${id}/organization-unit/${unitId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success(`Unit decision ${isMaker ? "maker" : "receiver"} - removed`);
				return res;
			} else {
				toast.error(`Unit decision ${isMaker ? "maker" : "receiver"} failed to be deleted`);
			}
		})
		.catch((err) => {
			return err.response;
		});
}
